/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackendApiApiV2ActualVehicleStateVehicleStateData
 */
export interface BackendApiApiV2ActualVehicleStateVehicleStateData {
    /**
     * 
     * @type {Date}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleStateData
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleStateData
     */
    ignition: number;
}

export function BackendApiApiV2ActualVehicleStateVehicleStateDataFromJSON(json: any): BackendApiApiV2ActualVehicleStateVehicleStateData {
    return BackendApiApiV2ActualVehicleStateVehicleStateDataFromJSONTyped(json, false);
}

export function BackendApiApiV2ActualVehicleStateVehicleStateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackendApiApiV2ActualVehicleStateVehicleStateData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'ignition': json['ignition'],
    };
}

export function BackendApiApiV2ActualVehicleStateVehicleStateDataToJSON(value?: BackendApiApiV2ActualVehicleStateVehicleStateData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'ignition': value.ignition,
    };
}


